const base = "/gestion-administrative-";

export const villes = [
  {
    slug: "bayonne",
    name: "Bayonne",
    dept: "64",
    region: "Pays Basque — côte basque",
    distance: "25 min de Guiche",
    path: `${base}bayonne`,
    title: "Gestion administrative à Bayonne (64) — ARGIA Admin",
    description:
      "Gestionnaire administrative indépendante à Bayonne et sur la côte basque : facturation, pré-comptabilité, RH, démarches en ligne pour artisans, commerçants, TPE et particuliers. Premier rendez-vous offert.",
    h1: ["Gestion administrative", "à Bayonne"],
    intro:
      "Capitale économique du Pays Basque, Bayonne concentre commerces de centre-ville, artisans du bâtiment, professions libérales et une multitude de TPE. Entre le Petit Bayonne, Saint-Esprit et les zones d'activité de l'agglomération, le temps manque souvent pour tenir à jour la paperasse.",
    context:
      "J'interviens régulièrement à Bayonne et dans toute l'agglomération côte basque — Anglet, Biarritz, Boucau, Tarnos, Saint-Pierre-d'Irube, Mouguerre. Basée à Guiche, je suis à moins de 30 minutes de votre entreprise ou de votre domicile, et je peux aussi vous accompagner entièrement à distance.",
    publics: [
      "Commerçants et restaurateurs du centre-ville et des halles",
      "Artisans du bâtiment, de la rénovation et des métiers de bouche",
      "Professions libérales et indépendants (santé, conseil, bien-être)",
      "Associations culturelles, sportives et festives bayonnaises",
      "Particuliers et retraités souhaitant être épaulés dans leurs démarches",
    ],
    besoins: [
      "Tenir une facturation à jour malgré un rythme intense, notamment en saison et pendant les Fêtes de Bayonne",
      "Préparer les pièces comptables pour votre expert-comptable sans y passer vos soirées",
      "Gérer l'administratif du personnel : contrats, DPAE, suivi des absences",
      "Répondre aux demandes de l'URSSAF, des impôts, de la CAF ou de la CPAM",
    ],
    nearby: ["Anglet", "Biarritz", "Boucau", "Tarnos", "Saint-Pierre-d'Irube", "Mouguerre"],
    faqs: [
      {
        q: "Vous déplacez-vous dans mes locaux à Bayonne ?",
        a: "Oui. Je peux intervenir directement dans votre commerce, votre atelier, votre cabinet ou à votre domicile à Bayonne et dans l'agglomération (Anglet, Biarritz, Boucau…). Le travail à distance est également possible, en totalité ou en complément.",
      },
      {
        q: "Combien coûte une gestionnaire administrative à Bayonne ?",
        a: "Le tarif dépend de la mission : ponctuelle (remise à plat, dossier précis) ou forfait mensuel. Après un premier rendez-vous offert, je vous remets un devis gratuit, transparent et sans engagement.",
      },
      {
        q: "Travaillez-vous avec des commerces saisonniers de la côte basque ?",
        a: "Tout à fait. Je m'adapte à votre saisonnalité : accompagnement renforcé pendant les pics d'activité, allégé le reste de l'année.",
      },
    ],
  },
  {
    slug: "peyrehorade",
    name: "Peyrehorade",
    dept: "40",
    region: "Sud Landes — Pays d'Orthe",
    distance: "10 min de Guiche",
    path: `${base}peyrehorade`,
    title: "Gestion administrative à Peyrehorade (40) — ARGIA Admin",
    description:
      "Gestionnaire administrative indépendante à Peyrehorade et dans le Pays d'Orthe : facturation, dossiers, pré-comptabilité, démarches en ligne pour artisans, agriculteurs, TPE et particuliers. Premier rendez-vous offert.",
    h1: ["Gestion administrative", "à Peyrehorade"],
    intro:
      "Au cœur du Pays d'Orthe, au bord des Gaves réunis, Peyrehorade est un bourg commerçant et artisanal vivant, avec son marché, ses entreprises agroalimentaires et ses exploitations agricoles. Un tissu de petites structures où l'administratif repose souvent sur une seule personne.",
    context:
      "Guiche est à dix minutes de Peyrehorade : c'est mon secteur le plus proche. J'interviens dans tout le Pays d'Orthe et le Sud des Landes — Hastingues, Sorde-l'Abbaye, Labatut, Pouillon, Saint-Lon-les-Mines, Orthevielle, Port-de-Lanne — sur site ou à distance.",
    publics: [
      "Artisans et commerçants du bourg et du marché du mercredi",
      "Exploitants agricoles, producteurs de kiwis, maïsiculteurs et éleveurs",
      "Entreprises agroalimentaires et de services du Pays d'Orthe",
      "Indépendants et professions libérales",
      "Particuliers, familles et retraités du secteur",
    ],
    besoins: [
      "Suivre devis, factures et relances clients sans y laisser vos week-ends",
      "Préparer et classer les justificatifs pour le comptable ou le centre de gestion",
      "Constituer des dossiers d'aides, de subventions ou de déclarations (MSA, PAC, URSSAF)",
      "Dématérialiser et organiser des années de papiers accumulés",
    ],
    nearby: ["Hastingues", "Sorde-l'Abbaye", "Labatut", "Pouillon", "Saint-Lon-les-Mines", "Orthevielle", "Port-de-Lanne"],
    faqs: [
      {
        q: "Intervenez-vous dans les exploitations agricoles autour de Peyrehorade ?",
        a: "Oui. J'accompagne les exploitants dans leur suivi administratif courant : facturation, classement des pièces, préparation des dossiers pour le centre de gestion, suivi des échéances MSA et démarches en ligne.",
      },
      {
        q: "Pouvez-vous venir à Peyrehorade pour une mission ponctuelle ?",
        a: "Bien sûr. Remise à plat d'un classement, rattrapage de facturation, dossier précis : je peux intervenir une seule fois, sans engagement sur la durée.",
      },
      {
        q: "Quels sont vos délais d'intervention dans le Pays d'Orthe ?",
        a: "Étant basée à Guiche, à quelques minutes de Peyrehorade, je peux généralement vous proposer un premier rendez-vous sous une semaine, en présentiel ou en visio.",
      },
    ],
  },
  {
    slug: "hasparren",
    name: "Hasparren",
    dept: "64",
    region: "Pays Basque intérieur — Labourd",
    distance: "30 min de Guiche",
    path: `${base}hasparren`,
    title: "Gestion administrative à Hasparren (64) — ARGIA Admin",
    description:
      "Gestionnaire administrative indépendante à Hasparren et dans le Labourd intérieur : facturation, pré-comptabilité, RH, démarches en ligne pour artisans, commerçants, TPE et particuliers. Premier rendez-vous offert.",
    h1: ["Gestion administrative", "à Hasparren"],
    intro:
      "Porte du Pays Basque intérieur, Hasparren conjugue tradition artisanale — cuir, chaussure, bâtiment — et dynamisme commercial. Les entreprises familiales et les indépendants y sont nombreux, et chacun jongle entre son métier et une administration de plus en plus dématérialisée.",
    context:
      "J'interviens à Hasparren et dans les communes du Labourd intérieur — Briscous, Urt, La Bastide-Clairence, Ayherre, Bonloc, Mendionde, Macaye, Cambo-les-Bains. Depuis Guiche, je rejoins Hasparren en une trentaine de minutes ; je travaille aussi à distance.",
    publics: [
      "Artisans du bâtiment, menuisiers, charpentiers et métiers d'art",
      "Commerçants et restaurateurs du centre-bourg",
      "Entreprises familiales et PME de la zone d'activité",
      "Indépendants, professions libérales et paramédicales",
      "Particuliers, agriculteurs et retraités du Labourd",
    ],
    besoins: [
      "Structurer la facturation et les devis pour sécuriser votre trésorerie",
      "Préparer la pré-comptabilité et dialoguer avec votre expert-comptable",
      "Gérer les formalités liées à vos salariés et apprentis",
      "Suivre les démarches en ligne (impots.gouv, URSSAF, ANTS, CAF) sans stress",
    ],
    nearby: ["Briscous", "Urt", "La Bastide-Clairence", "Ayherre", "Bonloc", "Mendionde", "Cambo-les-Bains"],
    faqs: [
      {
        q: "Vous déplacez-vous jusqu'à Hasparren et Cambo-les-Bains ?",
        a: "Oui. Hasparren et l'ensemble du Labourd intérieur font partie de ma zone d'intervention en présentiel. Pour un suivi régulier, nous pouvons alterner visites sur place et travail à distance.",
      },
      {
        q: "Accompagnez-vous les artisans dans leurs devis et factures ?",
        a: "C'est l'une de mes missions les plus fréquentes : mise en place d'un outil simple, émission des devis et factures, suivi des règlements et relances, pour que vous puissiez vous concentrer sur vos chantiers.",
      },
      {
        q: "Comment se passe le premier rendez-vous ?",
        a: "Il est offert et sans engagement. Nous faisons le point sur votre situation, en présentiel à Hasparren ou en visio, puis je vous propose un accompagnement et un devis adaptés.",
      },
    ],
  },
  {
    slug: "salies-de-bearn",
    name: "Salies-de-Béarn",
    dept: "64",
    region: "Béarn des Gaves",
    distance: "25 min de Guiche",
    path: `${base}salies-de-bearn`,
    title: "Gestion administrative à Salies-de-Béarn (64) — ARGIA Admin",
    description:
      "Gestionnaire administrative indépendante à Salies-de-Béarn et dans le Béarn des Gaves : facturation, dossiers, pré-comptabilité, démarches en ligne pour commerçants, artisans, TPE et particuliers. Premier rendez-vous offert.",
    h1: ["Gestion administrative", "à Salies-de-Béarn"],
    intro:
      "Cité du sel et ville thermale, Salies-de-Béarn vit au rythme de ses commerces, de ses hébergements touristiques, de ses artisans et de ses professionnels de santé et de bien-être. Une activité souvent saisonnière, où l'administratif s'accumule vite quand la saison bat son plein.",
    context:
      "J'interviens à Salies-de-Béarn et dans le Béarn des Gaves — Orthez, Sauveterre-de-Béarn, Puyoô, Bellocq, Carresse-Cassaber, Castagnède. À environ 25 minutes de Guiche, je viens à votre rencontre sur place ou travaille à distance selon votre préférence.",
    publics: [
      "Commerçants, restaurateurs et hébergeurs (gîtes, chambres d'hôtes, hôtels)",
      "Professionnels du thermalisme, de la santé et du bien-être",
      "Artisans et entreprises du bâtiment du Béarn des Gaves",
      "Indépendants et professions libérales",
      "Particuliers, curistes installés et retraités",
    ],
    besoins: [
      "Absorber les pics administratifs de la saison thermale et touristique",
      "Suivre la facturation, les encaissements et les relances",
      "Préparer les éléments comptables et sociaux pour vos conseils",
      "Accompagner les démarches en ligne et le passage au numérique",
    ],
    nearby: ["Orthez", "Sauveterre-de-Béarn", "Puyoô", "Bellocq", "Carresse-Cassaber", "Castagnède"],
    faqs: [
      {
        q: "Accompagnez-vous les gîtes et hébergements touristiques de Salies-de-Béarn ?",
        a: "Oui. Facturation, suivi des réservations et des règlements, déclarations liées à la taxe de séjour, classement des justificatifs : je prends en charge l'administratif pour que vous puissiez vous consacrer à l'accueil.",
      },
      {
        q: "Intervenez-vous aussi à Orthez et Sauveterre-de-Béarn ?",
        a: "Tout à fait, l'ensemble du Béarn des Gaves fait partie de ma zone d'intervention, en présentiel ou à distance.",
      },
      {
        q: "Peut-on vous confier uniquement la pré-comptabilité ?",
        a: "Oui. Je peux me limiter à la préparation et au classement des pièces pour votre expert-comptable, ou élargir la mission à la facturation et aux démarches selon vos besoins.",
      },
    ],
  },
  {
    slug: "guiche",
    name: "Guiche",
    dept: "64",
    region: "Pays Basque — Pays de Bidache",
    distance: "Mon bureau",
    path: `${base}guiche`,
    title: "Gestion administrative à Guiche (64) — ARGIA Admin",
    description:
      "ARGIA Admin, gestionnaire administrative indépendante basée à Guiche (64520) : facturation, pré-comptabilité, dossiers, démarches en ligne pour professionnels et particuliers du Pays de Bidache et de l'Adour. Premier rendez-vous offert.",
    h1: ["Gestion administrative", "à Guiche"],
    intro:
      "C'est à Guiche, entre Adour et Bidouze, qu'ARGIA Admin est installée. Village du Pays de Bidache tourné vers la nature, l'agriculture et l'artisanat, Guiche est aussi le point de départ de mes interventions dans tout le Pays Basque et le Sud des Landes.",
    context:
      "Être votre voisine, c'est pouvoir passer rapidement récupérer un dossier, travailler quelques heures dans vos locaux ou vous recevoir pour un point. J'accompagne les habitants et entreprises de Guiche et des communes voisines — Sames, Urt, Bardos, Came, Bidache, Hastingues, Lahonce, Urcuit.",
    publics: [
      "Artisans, agriculteurs et auto-entrepreneurs du village",
      "Commerces et services de proximité",
      "Indépendants travaillant depuis leur domicile",
      "Associations locales",
      "Particuliers, familles et retraités",
    ],
    besoins: [
      "Mettre en place une facturation simple et régulière",
      "Trier, classer et dématérialiser les documents de la maison ou de l'entreprise",
      "Préparer les pièces pour le comptable et suivre les échéances",
      "Réaliser les démarches en ligne (carte grise, retraite, CAF, impôts, URSSAF)",
    ],
    nearby: ["Sames", "Urt", "Bardos", "Came", "Bidache", "Hastingues", "Lahonce", "Urcuit"],
    faqs: [
      {
        q: "Où se trouve votre bureau ?",
        a: "ARGIA Admin est installée au 95 Chemin des Dames, 64520 Guiche. Je reçois sur rendez-vous et je me déplace volontiers chez vous.",
      },
      {
        q: "Peut-on déposer des documents directement à Guiche ?",
        a: "Oui, sur rendez-vous. Vous pouvez aussi me les transmettre de manière sécurisée par voie numérique, ce que je recommande pour gagner du temps.",
      },
      {
        q: "Accompagnez-vous les particuliers pour leurs démarches ?",
        a: "Absolument : dossiers retraite, CAF, impôts, ANTS, courriers administratifs, organisation des papiers du foyer. Je vous accompagne pas à pas, à votre domicile ou à distance.",
      },
    ],
  },
  {
    slug: "bidache",
    name: "Bidache",
    dept: "64",
    region: "Pays Basque — Pays de Bidache",
    distance: "10 min de Guiche",
    path: `${base}bidache`,
    title: "Gestion administrative à Bidache (64) — ARGIA Admin",
    description:
      "Gestionnaire administrative indépendante à Bidache et dans le Pays de Bidache : facturation, dossiers, pré-comptabilité, démarches en ligne pour artisans, commerçants, agriculteurs, TPE et particuliers. Premier rendez-vous offert.",
    h1: ["Gestion administrative", "à Bidache"],
    intro:
      "Chef-lieu du Pays de Bidache, dominé par le château de Gramont, Bidache réunit commerces, artisans, exploitations agricoles et une vie associative active. Des structures à taille humaine où chaque heure passée sur l'administratif est une heure de moins pour le métier.",
    context:
      "Bidache est à dix minutes de mon bureau de Guiche : j'y interviens très régulièrement, ainsi que dans les communes du canton — Bardos, Came, Arancou, Bergouey-Viellenave, Sames, Guiche. Sur site, chez vous, ou à distance.",
    publics: [
      "Artisans du bâtiment et de l'aménagement",
      "Commerçants, restaurateurs et services du bourg",
      "Exploitants agricoles et producteurs locaux",
      "Indépendants et professions libérales",
      "Associations, particuliers et retraités",
    ],
    besoins: [
      "Tenir devis, factures et relances à jour",
      "Préparer les éléments pour l'expert-comptable ou le centre de gestion",
      "Gérer les formalités employeur et le suivi des salariés",
      "Simplifier les démarches dématérialisées auprès des organismes",
    ],
    nearby: ["Bardos", "Came", "Arancou", "Bergouey-Viellenave", "Sames", "Guiche"],
    faqs: [
      {
        q: "Intervenez-vous dans toutes les communes du Pays de Bidache ?",
        a: "Oui : Bidache, Bardos, Came, Arancou, Bergouey-Viellenave, Sames, Guiche… toutes les communes du canton font partie de mon secteur de proximité.",
      },
      {
        q: "Proposez-vous un accompagnement régulier aux petites entreprises ?",
        a: "Oui, sous forme de forfait mensuel adapté à votre volume : quelques heures par semaine ou par mois, en présentiel et/ou à distance, pour un administratif toujours à jour.",
      },
      {
        q: "Le premier rendez-vous est-il vraiment gratuit ?",
        a: "Oui, le rendez-vous découverte est offert et sans engagement. Il permet de cerner vos besoins et de vous proposer un devis clair.",
      },
    ],
  },
  {
    slug: "saint-palais",
    name: "Saint-Palais",
    dept: "64",
    region: "Pays Basque — Basse-Navarre",
    distance: "35 min de Guiche",
    path: `${base}saint-palais`,
    title: "Gestion administrative à Saint-Palais (64) — ARGIA Admin",
    description:
      "Gestionnaire administrative indépendante à Saint-Palais et en Basse-Navarre : facturation, pré-comptabilité, RH, démarches en ligne pour artisans, agriculteurs, commerçants, TPE et particuliers. Premier rendez-vous offert.",
    h1: ["Gestion administrative", "à Saint-Palais"],
    intro:
      "Carrefour de la Basse-Navarre et étape des chemins de Compostelle, Saint-Palais est un bourg commerçant et agricole dynamique, avec son marché du vendredi, ses artisans et ses entreprises agroalimentaires. L'administratif y est souvent géré « entre deux », faute de temps.",
    context:
      "J'interviens à Saint-Palais et dans les communes d'Amikuze et de Basse-Navarre — Garris, Béguios, Aïcirits-Camou-Suhast, Larribar-Sorhapuru, Uhart-Mixe, Arraute-Charritte, Saint-Jean-Pied-de-Port. Depuis Guiche, je rejoins Saint-Palais en 35 minutes environ ; je travaille aussi à distance.",
    publics: [
      "Artisans et entreprises du bâtiment",
      "Commerçants et exposants du marché",
      "Exploitants agricoles, éleveurs et producteurs fermiers",
      "Indépendants, professions libérales et paramédicales",
      "Associations, particuliers et retraités",
    ],
    besoins: [
      "Facturer et relancer régulièrement pour une trésorerie saine",
      "Préparer la pré-comptabilité et les dossiers MSA, PAC ou URSSAF",
      "Gérer l'administratif du personnel et des saisonniers",
      "Accompagner les démarches en ligne et l'organisation documentaire",
    ],
    nearby: ["Garris", "Béguios", "Aïcirits-Camou-Suhast", "Uhart-Mixe", "Arraute-Charritte", "Saint-Jean-Pied-de-Port"],
    faqs: [
      {
        q: "Vous déplacez-vous jusqu'en Basse-Navarre ?",
        a: "Oui. Saint-Palais et l'Amikuze font partie de ma zone d'intervention en présentiel. Pour un suivi régulier, nous pouvons combiner visites sur place et travail à distance pour limiter les déplacements.",
      },
      {
        q: "Accompagnez-vous les producteurs fermiers et éleveurs ?",
        a: "Oui : facturation des ventes directes, classement des pièces, suivi des échéances et des dossiers d'aides, démarches auprès de la MSA et des organismes agricoles.",
      },
      {
        q: "Comment prendre rendez-vous ?",
        a: "Directement en ligne sur ce site : quelques questions rapides, un créneau synchronisé avec mon agenda, et vous recevez une confirmation immédiate. Le premier rendez-vous est offert.",
      },
    ],
  },
];

export const findVille = (pathname) => villes.find((v) => v.path === pathname);
